import { sample } from 'effector';
import {
  $drawMode,
  $hexagonsHeight,
  $interactivity,
  $layersOpacity,
  $mapLoaded,
  $rbpLayer,
  $searchOptions,
  $invertHeight,
  $fullScreen,
} from './stores.js';
import {
  changeDrawModeEv,
  changeHexagonsHeightEv,
  changeInteractivityEv,
  changeLayersOpacityEv,
  changeRbpLayerEv,
  putSearchOptionsEv,
  resetMapLoadedEv,
  setMapLoadedEv,
  changeInvertHeightEv,
  toggleFullScreenEv,
} from './events.js';
import { $presetAreaToEdit } from '../dataPresetsModel/index.js';
import { $zoom9Hexagons } from '../zoom9Model/index.js';
import { calculateThresholdsEv } from '../gradientModel/index.js';
import { calculateByMetricEv } from '../activeFiltersModel/index.js';

$mapLoaded.on(setMapLoadedEv, (_, payload) => payload).reset(resetMapLoadedEv);

$interactivity.on(changeInteractivityEv, (_, payload) => payload);

$searchOptions.on(putSearchOptionsEv, (_, payload) => payload);

$drawMode.on(changeDrawModeEv, (_, payload) => payload);

$layersOpacity.on(changeLayersOpacityEv, (_, payload) => payload);

$hexagonsHeight.on(changeHexagonsHeightEv, (_, payload) => payload);

$rbpLayer.on(changeRbpLayerEv, (_, payload) => payload);

$fullScreen.on(toggleFullScreenEv, (state, payload) => {
  if (typeof payload === 'boolean') return payload;
  return !state;
});

sample({
  clock: $presetAreaToEdit.updates,
  fn: (clock) => !clock.preset,
  target: changeInteractivityEv,
});

sample({
  source: $invertHeight,
  clock: changeInvertHeightEv,
  fn: (source, clock) => {
    if (typeof clock === 'boolean') {
      return clock;
    }
    return !source;
  },
  target: $invertHeight,
});

sample({
  source: $zoom9Hexagons,
  clock: $rbpLayer.updates,
  fn: (source) => source,
  target: calculateThresholdsEv,
});

sample({
  clock: calculateByMetricEv,
  fn: () => 'index',
  target: $rbpLayer,
});
